import { Anchor } from "@mantine/core";
import { useDownload } from "../../../hooks/useDownload";
import type { Person } from "../../../utils/backend-types";

interface FileCellProps {
  url: string;
  prefix: string;
  supplierId?: number;
  suppliedId?: number;
  persons: Array<Person>;
  billingPeriodStart?: string;
  icon?: string;
}

export function FileCell({
  url,
  prefix,
  supplierId,
  suppliedId,
  persons,
  billingPeriodStart,
  icon
}: FileCellProps) {
  const supplier = supplierId
    ? persons.find((person) => person.id === supplierId)
    : undefined;
  const supplied = suppliedId
    ? persons.find((person) => person.id === suppliedId)
    : undefined;
  const supplierName = supplier ? supplier.name : "<Kein_Lieferant>";
  const suppliedName = supplied ? supplied.name : "<Kein_Belieferter>";
  const billingPeriod = billingPeriodStart || "<Kein_Abrechnungsbeginn>";
  const text = `${prefix}_${supplierName}_${suppliedName}_${billingPeriod}`;
  const { download } = useDownload();

  return (
    <>
      {icon && (
        <img
          className="invoice-file-icon"
          src={icon}
          style={{ width: "1.1em" }}
        />
      )}
      <Anchor
        component="button"
        type="button"
        variant="external"
        onClick={() => download({ downloadUrl: url })}
      >
        {text}
      </Anchor>
    </>
  );
}
